import { NavLink as MantineNavLink, type NavLinkProps as MantineNavLinkProps } from '@mantine/core';
import { createLink, type LinkComponent } from '@tanstack/react-router';
import { forwardRef } from 'react';

type RouterNavLinkProps = Omit<MantineNavLinkProps, 'component'>;

const RouterNavLinkComponent = forwardRef<HTMLAnchorElement, RouterNavLinkProps>((props, ref) => (
	<MantineNavLink component='a' ref={ref} {...props} />
));

export const NavLink: LinkComponent<typeof RouterNavLinkComponent> =
	createLink(RouterNavLinkComponent);
